import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "ticketino-api-client";

import Header from "./components/Header";
import Footer from "./components/Footer";

import iconStarDoubleLeft from "../images/icons/star_double_left.svg"
import iconArrowUp from "../images/icons/arrow_up.svg"

const Confirmation = () => {
    const [token] = useState(sessionStorage.getItem("token"));
    const [order, setOrder] = useState([]);
    const [organizerId, setOrganizerId] = useState(0);
    const [firstName, setFirstName] = useState(sessionStorage.getItem("buyerFirstName") || "");

    const [isDeregistration] = useState(sessionStorage.getItem("IsRegeristration"));

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching resources
    const { language, orderId } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        case ("it" || "IT"):
            languageId = 4;
            break;
        default:
            languageId = 0;
            break;
    }

    useEffect(() => {
        //// gtm - purchase
        //window.dataLayer = window.dataLayer || [];
        //window.dataLayer.push({
        //    'event': 'purchase'
        //});

        // Scroll to the registration section when page loads
        setTimeout(() => {
            registrationRef.current?.scrollIntoView({
                behavior: 'auto',
                block: 'start'
            });
        }, 100);
    }, [])

    useEffect(() => {
        loadToken();
    }, []); //only on first page load

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const loadToken = async () => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        //remove orerId from session
        sessionStorage.removeItem("orderId");

        requestFormSettings()
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            setOrganizerId(res.data.organizerId);
            loadOrder(orderId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId) => {
        try {
            // Order
            const order = await getOrderByOrderId(orderId);

            setOrder(order);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const registrationRef = useRef(null);

    const scrollToRegistration = () => {
        registrationRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <Header
                firstName={firstName}
                onScrollToRegistration={scrollToRegistration}
            />
            <div className="container page-container title-margin-top ps-4 pe-4" ref={registrationRef}>

                {/* Registration */}
                <div className="row mt-4 confirmation-box">
                    <div className="col-md-12 text-center">
                        <img src={iconStarDoubleLeft} className="icon-star-double-left" alt="" />
                        <span className="title">{resources?.ConfirmationTitle}</span>
                    </div>
                    <div className="col-md-12 mt-4 text-center">
                        <span dangerouslySetInnerHTML={{ __html: resources?.ConfirmationDescription }}></span>
                    </div>
                </div>
            </div>

            <Footer language={language} />

            {/* Scroll to top button */}
            <button
                className="scroll-to-top"
                onClick={scrollToTop}
                aria-label="Scroll to top"
            >
                <img src={iconArrowUp} alt="Scroll to top" />
            </button>
        </>
    )
}

export default Confirmation